var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 21.5,
    height: 21.5,
    rx: 2.75,
    stroke: "#DADADA",
    strokeWidth: 0.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_14018)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.7061 12.1144V14.7059C14.7061 14.9633 14.6038 15.2102 14.4218 15.3922C14.2398 15.5742 13.9929 15.6765 13.7355 15.6765H6.94135C6.68394 15.6765 6.43706 15.5742 6.25504 15.3922C6.07302 15.2102 5.97076 14.9633 5.97076 14.7059V7.91175C5.97076 7.65433 6.07302 7.40746 6.25504 7.22544C6.43706 7.04342 6.68394 6.94116 6.94135 6.94116H9.53282",
    stroke: "#1D64C8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7354 5.9707L15.6766 7.91188L10.8237 12.7648H8.88251V10.8236L13.7354 5.9707Z",
    stroke: "#1D64C8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_14018"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11.6471,
    height: 11.6471,
    fill: "white",
    transform: "translate(5.00018 5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/EditIcon.55930b38496be1bccdad5e19fdcaa33b.svg";
export { ForwardRef as ReactComponent };